<button
  [id]="'mapscalebutton'"
  #scaleText
  class="scaleText"
  #scaleInputTrigger="matMenuTrigger"
  [matMenuTriggerFor]="scaleMenu"
  (click)="buttonClick($event)"
>
  {{ scaleDisplayText }}
</button>
<mat-menu #scaleMenu="matMenu" class="searchMenu" xPosition="after" yPosition="above">
  <div class="searchFormField scalePanel">
    <abcAutoCompleteInput
      #autoComplete
      id="mapScaleSearch"
      [placeHolder]="res.get('Controls-MapScaleText-SetScale')"
      small="true"
      clearAfterSubmit="false"
      (submit)="applyScale($event)"
    ></abcAutoCompleteInput>
  </div>
</mat-menu>
